import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop ordering for a list of rows. On drop it POSTs the new order of
// the rows' data-sortable-id values to the configured URL so the server can
// persist it. Rows must carry data-sortable-id; the controller element carries
// data-sortable-url-value with the reorder endpoint.
export default class extends Controller {
  static values = { url: String, handle: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: this.hasHandleValue ? this.handleValue : undefined,
      onEnd: () => this.persist()
    })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  persist() {
    const ids = Array.from(this.element.querySelectorAll("[data-sortable-id]"))
      .map((el) => el.dataset.sortableId)

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new URLSearchParams()
    ids.forEach((id) => body.append("faq_ids[]", id))

    fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token, Accept: "application/json" },
      body
    })
  }
}
